"use client"

import { CheckCircle, Clock, AlertTriangle } from "lucide-react";
import { motion } from "framer-motion"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "../../../components/ui/card"
import "../../../components/ui/badge";

export default function FlowItem({ flow, onClick, loading = false }) {
  if (loading) {
    return (
      <motion.div
        whileHover={{ scale: 1.02 }}
        transition={{ type: "spring", stiffness: 400, damping: 17 }}
      >
        <Card className="h-full border border-slate-200 dark:border-slate-700">
          <CardHeader className="pb-2">
            <div className="h-6 w-3/4 bg-slate-200 dark:bg-slate-700 rounded animate-pulse"></div>
          </CardHeader>
          <CardContent>
            <div className="h-4 w-full bg-slate-200 dark:bg-slate-700 rounded animate-pulse mb-2"></div>
            <div className="h-4 w-2/3 bg-slate-200 dark:bg-slate-700 rounded animate-pulse"></div>
          </CardContent>
          <CardFooter>
            <div className="h-4 w-1/2 bg-slate-200 dark:bg-slate-700 rounded animate-pulse"></div>
          </CardFooter>
        </Card>
      </motion.div>
    )
  }

  
  
  
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: "spring", stiffness: 400, damping: 17 }}
    >
      <Card
        className="cursor-pointer h-full border border-slate-200 dark:border-slate-700 hover:border-orange-300 dark:hover:border-orange-500 transition-all duration-200"
        onClick={() => onClick(flow)}
      >
        <CardHeader className="pb-2">
          <div className="flex justify-between items-start">
            <CardTitle className="text-xl font-bold text-slate-800 dark:text-slate-100">{flow.name}</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-slate-600 dark:text-slate-300 mb-4">{flow.description}</p>
        </CardContent>
        <CardFooter>
          {/* <div className="flex items-center text-slate-500 dark:text-slate-400">
            <FileText className="h-4 w-4 mr-2" />
            <span>0 documentos procesados</span>
          </div> */}
        </CardFooter>
      </Card>
    </motion.div>
  )
}

